import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminReports from "./pages/AdminReports";
import AdminLeadDetails from "./pages/AdminLeadDetails";
import AdminEmployeeHistory from "./pages/AdminEmployeeHistory";
import ManageEmployees from "./pages/ManageEmployees";
import ManageLeads from "./pages/ManageLeads";

import EmployeeLogin from "./pages/EmployeeLogin";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import EmployeeCalls from "./pages/EmployeeCalls";
import EmployeeCallbacks from "./pages/EmployeeCallbacks";
import EmployeeProspects from "./pages/EmployeeProspects";
import EmployeeWorkQueue from "./pages/EmployeeWorkQueue";
import EmployeeConverted from "./pages/EmployeeConverted";
import EmployeeReports from "./pages/EmployeeReports";

import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <AdminLogin />
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <AdminDashboard />
          }
        />

        <Route
          path="/admin-reports"
          element={
            <AdminReports />
          }
        />

        <Route
          path="/admin-lead/:leadId"
          element={
            <AdminLeadDetails />
          }
        />

        <Route
          path="/admin-employee-history/:employeeId"
          element={
            <AdminEmployeeHistory />
          }
        />

        <Route
          path="/manage-employees"
          element={
            <ManageEmployees />
          }
        />

        <Route
          path="/manage-leads"
          element={
            <ManageLeads />
          }
        />

        <Route
          path="/employee-login"
          element={
            <EmployeeLogin />
          }
        />

        <Route
          path="/employee-dashboard"
          element={
            <EmployeeDashboard />
          }
        />

        <Route
          path="/employee-calls"
          element={
            <EmployeeCalls />
          }
        />

        <Route
          path="/employee-callbacks"
          element={
            <EmployeeCallbacks />
          }
        />

        <Route
          path="/employee-prospects"
          element={
            <EmployeeProspects />
          }
        />

        <Route
          path="/employee-work-queue"
          element={
            <EmployeeWorkQueue />
          }
        />

        <Route
          path="/employee-converted"
          element={
            <EmployeeConverted />
          }
        />

        <Route
          path="/employee-reports"
          element={
            <EmployeeReports />
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;